import React from "react";
import "./Cart.css";

const Cart = ({ cart, handleRemoveItem }) => {
  let message;
  if (cart.length === 0) {
    message = <p>Please choose at least one item!!!</p>;
  } else {
    message = <p>Thanks for ordering</p>;
  }
  return (
    <div className="">
      <h2 className={cart.length > 2 ? `orange` : `purple`}>Order summary</h2>
      <h4 className={cart.length === 4 ? `yellow` : `red`}>
        Order Quantity: {cart.length}
      </h4>
      {cart.map((tshirt) => (
        <p key={tshirt._id}>
          {tshirt.name}
          <button onClick={() => handleRemoveItem(tshirt)}>X</button>
        </p>
      ))}
      {message}
      {cart.length === 3 ? <p>3 jon k diba?</p> : <p>Aro kino taile</p>}
      <p>And operator</p>
      {cart.length === 2 && <h2>Double item</h2>}
      <p>Or operator</p>
      {cart.length === 4 || <h4>charta item na</h4>}
    </div>
  );
};

export default Cart;
/*
Conditional Rendering
1. Use element in a variable and then use if-else to set the value
2. Ternary operator condition ? true: false
3. && operator(if condition is true, i wanna display something)
4. || operator(if condition is false,i wanna display something)

*/
